'use client';

import type { ReactNode } from 'react';
import type { ToolUIPart } from 'ai';

import { ToolActivityLine } from './ToolActivityLine';
import { cn } from '@/lib/utils';

export type ToolPartCustomRendererArgs = {
  toolName: string;
  toolCallId: string;
  state: ToolUIPart['state'];
  input: unknown;
  output?: unknown;
  errorText?: string;
};

export type ToolPartCustomRenderer = (args: ToolPartCustomRendererArgs) => ReactNode;

export interface ToolPartProps {
  toolName: string;
  toolCallId: string;
  state: ToolUIPart['state'];
  input: unknown;
  output?: unknown;
  errorText?: string;
  customRenderer?: ToolPartCustomRenderer;
}

export function ToolPart({
  toolName,
  toolCallId,
  state,
  input,
  output,
  errorText,
  customRenderer,
}: ToolPartProps) {
  const args: ToolPartCustomRendererArgs = {
    toolName,
    toolCallId,
    state,
    input,
    output,
    errorText,
  };

  return (
    <div>
      <ToolActivityLine toolName={toolName} state={state} />

      {customRenderer ? (
        customRenderer(args)
      ) : (
        <>
          {state === 'output-error' && errorText ? (
            <p className={cn('not-prose mb-4 text-[11px] font-medium text-destructive')}>
              {errorText}
            </p>
          ) : null}
        </>
      )}
    </div>
  );
}
